/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_SearchInputs */



/**

* @param {_Filter_SearchInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _filter_search = /** @type {((inputs?: _Filter_SearchInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_SearchInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Suchen")
});